import { Spin } from "../../../core/Spin";
import * as React from "react";

export class MetricVisualizationLoadSpin extends React.Component<any, any> {
  render() {
    return (
      <div
        className="metric-loading-spinner"
        style={{
          height: "500px",
          textAlign: "center",
          background: "rgba(255, 255, 255, 0.9)",
          paddingTop: "230px"
        }}
      >
        <Spin />
      </div>
    );
  }
}

export class QuerySelectorLoadSpin extends React.Component<any, any> {
  render() {
    return (
      <div
        className="loading-spinner"
        style={{
          height: "69%",
          textAlign: "center",
          background: "rgba(255, 255, 255, 0.9)",
          paddingTop: "120px"
        }}
      >
        <Spin />
      </div>
    );
  }
}

export class MetricsContainerLoadSpin extends React.Component<any, any> {
  render() {
    return (
      <div
        className="analytics-spiner section"
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          height: "500px",
          textAlign: "center",
          paddingTop: "240px",
          marginTop: "15px"
        }}
      >
        <Spin />
      </div>
    );
  }
}

export const FullscreenSpin = (props: any) => (
  <div
    className="fullscreen-spinner"
    style={{
      backgroundColor: "rgba(255, 255, 255, 0.9)",
      zIndex: 10999,
      height: "calc(100% - 75px)",
      width: "100%",
      position: "absolute",
      top: 75,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }}
  >
    <Spin size="large" />
  </div>
);



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/components/Spin/index.tsx